var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5298 9.46984L9.46984 14.5298C8.79884 13.8588 8.42188 12.9488 8.42188 11.9998C8.42188 11.53 8.51442 11.0647 8.69423 10.6306C8.87404 10.1965 9.13759 9.80208 9.46984 9.46984C9.80208 9.13759 10.1965 8.87404 10.6306 8.69423C11.0647 8.51442 11.53 8.42188 11.9998 8.42188C12.9488 8.42188 13.8588 8.79884 14.5298 9.46984Z",
    stroke: "#6D77A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8198 5.77047C16.0698 4.45047 14.0698 3.73047 11.9998 3.73047C8.46984 3.73047 5.17984 5.81047 2.88984 9.41047C1.98984 10.8205 1.98984 13.1905 2.88984 14.6005C3.67984 15.8405 4.59984 16.9105 5.59984 17.7705M8.41984 19.5305C9.55984 20.0105 10.7698 20.2705 11.9998 20.2705C15.5298 20.2705 18.8198 18.1905 21.1098 14.5905C22.0098 13.1805 22.0098 10.8105 21.1098 9.40047C20.7798 8.88047 20.4198 8.39047 20.0498 7.93047",
    stroke: "#6D77A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.51 12.7C15.3745 13.3976 15.0337 14.0387 14.5312 14.5412C14.0287 15.0437 13.3876 15.3845 12.69 15.52M9.47 14.53L2 22M22 2L14.53 9.47",
    stroke: "#6D77A0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.1e6a5f31d7cd1de57c6b6aa4324e6283.svg";
export { ForwardRef as ReactComponent };